"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeroImage = exports.StyledHeroImageBackground = exports.StyledHeroImageWrapper = exports.StyledCTA = exports.StyledHeading = exports.StyledHeroWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@phishtool/ui");
const heading_1 = require("~components/heading");
exports.StyledHeroWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledHeroWrapper", componentId: "sc-cp3prg" }) `
  ${ui_1.backgroundGradient}
`;
exports.StyledHeading = (0, styled_components_1.default)(heading_1.Heading).withConfig({ displayName: "StyledHeading", componentId: "sc-hkv9wt" }) `
  margin-bottom: ${(props) => props.theme.spacers.x3};

  ${(props) => (0, ui_1.mq)({
    marginTop: [props.theme.spacers.x4, null, props.theme.spacers.x8],
})}
`;
exports.StyledCTA = (0, styled_components_1.default)(ui_1.Button).withConfig({ displayName: "StyledCTA", componentId: "sc-1smp7vo" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  flex: 1;
  min-width: 0;

  ${(props) => (0, ui_1.mq)({
    flex: [1, 'none'],
    width: ['auto', '160px', '255px'],
    height: [props.theme.spacers.x6, null, props.theme.spacers.x9],
})}
`;
exports.StyledHeroImageWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledHeroImageWrapper", componentId: "sc-1onq3kf" }) `
  position: relative;
`;
exports.StyledHeroImageBackground = styled_components_1.default.div.withConfig({ displayName: "StyledHeroImageBackground", componentId: "sc-1ryt68o" }) `
  position: absolute;
  top: 0;
  left: 0;
  height: 50%;
  width: 100%;
  ${ui_1.backgroundGradient}
`;
exports.StyledHeroImage = styled_components_1.default.img.withConfig({ displayName: "StyledHeroImage", componentId: "sc-16ek8kk" }) `
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  aspect-ratio: 1.756;

  ${(props) => (0, ui_1.mq)({
    boxShadow: props.theme.shadows.tertiary,
    borderRadius: ['5px', '10px', '15px'],
})}
`;
